import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkUnSavePopUpVisible, getUserDetails, getUserName } from '../../../config/utils';
import { getEmployeeAssessmentList, getIsUserExluded } from '../../../action/perform';
import { AssessmentHeader } from '../Common/AssessmentHeader';
import { AssessmentQuestion } from '../Common/AssessmentQuestion';
import { useTranslation } from 'react-i18next';
import { Avatar, Box, Link, Typography } from '@material-ui/core';
import { OKRButton } from '../../Common/OKRButton';
import { RequestOneOnOneIcon2 } from '../../../config/svg/PersonalFeedbackSvg';
import assessmentNodata from '../../../images/assessment-no-data.svg';
import assessmentYetToBegin from '../../../images/assessment-yet-to-begin.svg';
import '../../../styles/pages/perform/assessmentHeaderBox.scss';
import '../../../styles/pages/perform/performanceAssessment.scss';
import { Enums } from '../../../config/enums';
import AlertDialog from '../../Common/Dialog';
import { BackArrow } from '../../../config/svg/GlobalSvg';
import { getOkrMasterData } from '../../../action/myGoal';

export const EmployeeAssessment = (props: any) => {
	const { handleOneOnOneClick, selectedUserAssessment } = props;
	const dispatch = useDispatch();
	const {
		employeeAssessmentResponse,
		employeeAssessmentResponseStatus,
		employeeAssessmentCycleList,
		employeeAssessmentCycleListStatus,
		performanceCycle,
	} = useSelector((state: any) => state.performReducer);
	const { okrMasterData } = useSelector((state: any) => state.okrReducer);

	const { t } = useTranslation();

	const [showManagerEvaluation, setShowManagerEvaluation] = React.useState<boolean>(false);
	const [assesmentData, setAssesmentData] = React.useState<any[]>([]);
	const [userExluded, setUserExluded] = React.useState<any>(null);
	const [isFormEdited, setIsFormEdited] = useState<boolean>(false);
	const [modalProps, setModalProps] = useState<any>({ open: false, event: {} });
	const [performanceRatings, setPerformanceRatings] = useState<any>([]);

	const ref = useRef<any>(null);
	const ref1 = useRef<any>(null);
	const ref2 = useRef<any>(null);

	useEffect(() => {
		if (!Boolean(okrMasterData)) {
			dispatch(getOkrMasterData());
		}
	});

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, [isFormEdited]);

	useEffect(() => {
		if (okrMasterData?.performanceRatings) {
			setPerformanceRatings(okrMasterData.performanceRatings);
		}
	}, [okrMasterData]);

	const handleClickOutside = (event: any) => {
		if (
			ref.current &&
			(ref1.current?.contains(event.target) ||
				ref2.current?.contains(event.target) ||
				!ref.current?.contains(event.target) ||
				event.target.id === 'back-btn') &&
			checkUnSavePopUpVisible(event) &&
			isFormEdited
		) {
			const dialogDiv = document.getElementsByClassName('MuiDialog-paper');
			if (dialogDiv.length === 0 || !dialogDiv[0].contains(event.target)) {
				event.preventDefault();
				event.stopPropagation();
				setModalProps({ open: true, event: event });
			}
		} else {
		}
	};
	const handleCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			await setIsFormEdited(false);
			const { target } = modalProps.event;
			const clonedNativeEvent = document.createEvent('HTMLEvents');
			clonedNativeEvent.initEvent('click', true, false);
			target.dispatchEvent(clonedNativeEvent);
		} else {
		}
		setModalProps({ open: false, event: {} });
	};

	const checkIsUserExcluded = async () => {
		let data = `performanceCycleId=${performanceCycle?.performanceCycleId}&employeeId=${props.employeeId}`;
		let response: any = await dispatch(getIsUserExluded(data));
		if (response.data.status === Enums.STATUS_SUCCESS) {
			setUserExluded(response.data.entity);
		}
	};

	useEffect(() => {
		if (employeeAssessmentResponse) {
			if (!props.fromTeamAssessment) {
				if (showManagerEvaluation) {
					if (!employeeAssessmentResponse?.isSelfRatingPercentage) {
						setAssesmentData([
							{
								managerRating: true,
								employeeQuestions: employeeAssessmentResponse.managerAssessmentQuestions,
								employeeDetailsResponse: employeeAssessmentResponse.managerDetailsResponse,
							},
						]);
					} else {
						setAssesmentData([
							...assesmentData,
							{
								managerRating: true,
								employeeQuestions: employeeAssessmentResponse.managerAssessmentQuestions,
								employeeDetailsResponse: employeeAssessmentResponse.managerDetailsResponse,
							},
						]);
					}
				} else {
					if (!employeeAssessmentResponse?.isSelfRatingPercentage) {
						setShowManagerEvaluation(true);
					} else {
						setAssesmentData([
							{
								...employeeAssessmentResponse,
								employeeQuestions: employeeAssessmentResponse.employeeAssessmentQuestions,
							},
						]);
					}
				}
			} else {
				if (showManagerEvaluation) {
					if (!employeeAssessmentResponse?.isSelfRatingPercentage) {
						setAssesmentData([
							{
								...employeeAssessmentResponse,
								managerRating: true,
								employeeQuestions: employeeAssessmentResponse.managerAssessmentQuestions,
								employeeDetailsResponse: employeeAssessmentResponse.managerDetailsResponse,
							},
						]);
					} else {
						setAssesmentData([
							...assesmentData,
							{
								employeeQuestions: employeeAssessmentResponse.employeeAssessmentQuestions,
								employeeDetailsResponse: employeeAssessmentResponse.employeeDetailsResponse,
							},
						]);
					}
				} else {
					setAssesmentData([
						{
							...employeeAssessmentResponse,
							managerRating: true,
							employeeQuestions: employeeAssessmentResponse.managerAssessmentQuestions,
							employeeDetailsResponse: employeeAssessmentResponse.managerDetailsResponse,
						},
					]);

					if (props.isFinalRating) {
						if (
							employeeAssessmentResponse?.isSelfRatingPercentage &&
							employeeAssessmentResponse?.isSelfAssessmentDone
						) {
							setShowManagerEvaluation(true);
						} else if (employeeAssessmentResponse?.isManagerAssessmentDone) {
							setShowManagerEvaluation(true);
						}
					}
				}
			}
		} else {
			//setAssesmentData([]);
		}
	}, [showManagerEvaluation, employeeAssessmentResponse]);

	const getEmployeeList = () => {
		if (!props.fromTeamAssessment) {
			fetchEmployee();
		} else {
			props.backClicked(true);
		}
	};

	const fetchEmployee = () => {
		let cycleId: any = performanceCycle?.performanceCycleId ? performanceCycle?.performanceCycleId : 1;
		let data = `empId=${props.employeeId}&performanceCycleId=${cycleId}`;
		dispatch(getEmployeeAssessmentList(data));
	};

	useEffect(() => {
		if (performanceCycle) {
			fetchEmployee();
			if (!props.fromTeamAssessment) {
				checkIsUserExcluded();
			} else {
				setUserExluded(false);
			}
		}
	}, [performanceCycle]);

	const finalSubmitted = () => {
		return (
			(!props.fromTeamAssessment &&
				!employeeAssessmentResponse?.isSelfRatingPercentage &&
				employeeAssessmentResponse?.isManagerAssessmentDone) ||
			(employeeAssessmentResponse?.isSelfAssessmentDone && !props.fromTeamAssessment) ||
			(employeeAssessmentResponse?.isManagerAssessmentDone && props.fromTeamAssessment)
		);
	};
	return (
		<>
			{employeeAssessmentCycleList && employeeAssessmentCycleList.length ? (
				!userExluded ? (
					<>
						{((employeeAssessmentResponseStatus &&
							employeeAssessmentResponse.employeeAssessmentQuestions.length === 0) ||
							(employeeAssessmentResponse &&
								!employeeAssessmentResponse?.isManagerAssessmentDone &&
								!employeeAssessmentResponse?.isSelfRatingPercentage)) &&
						!props.fromTeamAssessment ? (
							<Box className='assessment-no-record'>
								<Box className='no-record-message'>
									<Typography variant='h2'>{t('assessmentNoData1')}</Typography>
									<Typography>{t('assessmentNoData2')}</Typography>
									{employeeAssessmentResponse?.isOneToOneReview ? (
										<Box className='request1on1-messg'>
											<OKRButton
												handleClick={(e: any) => handleOneOnOneClick(e, 'MyAssessMentTab', 0)}
												icon={<RequestOneOnOneIcon2 />}
												text={t('requestOnetoOneText')}
											/>
											<Typography>{t('assessmentNoDataRequest1on1')}</Typography>
										</Box>
									) : (
										<></>
									)}
									<img width='485' alt={t('assessmentNoData1')} src={assessmentNodata} />
								</Box>
							</Box>
						) : (
							<div ref={ref}>
								{props.fromTeamAssessment && (
									<Box className='page-sub-head no-pad-bottom'>
										<Box className='back-to-main'>
											<Typography variant='body2' onClick={() => props.backClicked(false)}>
												<Link id='back-btn'>
													<BackArrow /> {t('back')}
												</Link>
											</Typography>
										</Box>
										<Box className='user-info'>
											<Box className='user-img'>
												<Avatar
													className='avatar-default'
													key={`user-icon-${selectedUserAssessment?.employeeDetailsResponse?.employeeId}`}
													src={selectedUserAssessment?.employeeDetailsResponse?.imagePath || ''}
												>
													{getUserName({
														firstName: selectedUserAssessment?.employeeDetailsResponse?.firstName || '',
														lastName: selectedUserAssessment?.employeeDetailsResponse?.lastName || '',
														fullName: selectedUserAssessment?.employeeDetailsResponse?.label || '',
													})}
												</Avatar>
											</Box>

											<Box className='user-info-details'>
												<Typography variant='h4'>
													{selectedUserAssessment?.employeeDetailsResponse?.firstName +
														' ' +
														selectedUserAssessment?.employeeDetailsResponse?.lastName}
												</Typography>
											</Box>
										</Box>
									</Box>
								)}
								{assesmentData.length > 0 && employeeAssessmentResponse && (
									<div>
										<AssessmentHeader
											employeeAssessmentResponse={employeeAssessmentResponse}
											showManagerEvaluation={showManagerEvaluation}
											setShowManagerEvaluation={setShowManagerEvaluation}
											fromTeamAssessment={props.fromTeamAssessment}
											isFinalRating={props.isFinalRating}
											getEmployeeList={getEmployeeList}
											handleOneOnOneClick={handleOneOnOneClick}
											employeeId={props.employeeId}
											ref1={ref1}
											ref2={ref2}
											okrMasterData={okrMasterData}
										/>
										<AssessmentQuestion
											employeeAssessmentResponse={employeeAssessmentResponse}
											employeeAssessment={assesmentData}
											getEmployeeList={getEmployeeList}
											fromTeamAssessment={props.fromTeamAssessment}
											finalSubmitted={finalSubmitted()}
											showManagerEvaluation={showManagerEvaluation}
											setShowManagerEvaluation={setShowManagerEvaluation}
											isFinalRating={props.isFinalRating}
											isFormEdited={isFormEdited}
											setIsFormEdited={setIsFormEdited}
											canEditQuestionsWithRating={
												(!props.fromTeamAssessment &&
													!performanceCycle?.isCycleCompleted &&
													employeeAssessmentResponse?.isSelfVisibleEnabled) ||
												(!performanceCycle?.isCycleCompleted &&
													employeeAssessmentResponse?.isManagerRatingEnabled &&
													props.fromTeamAssessment)
											}
											performanceRatings={performanceRatings}
										/>
									</div>
								)}
							</div>
						)}
					</>
				) : (
					<>
						<Box className='assessment-no-record'>
							<Box className='no-record-message'>
								<Typography variant='h2'>{t('assessmentYetToBegin1')}</Typography>
								<Typography>{t('assessmentYetToBegin2')}</Typography>
								<img width='470' alt={t('assessmentYetToBegin1')} src={assessmentYetToBegin} />
							</Box>
						</Box>
					</>
				)
			) : (
				<>
					<Box className='assessment-no-record'>
						<Box className='no-record-message'>
							<Typography variant='h2'>{t('assessmentYetToBegin1')}</Typography>
							<Typography>{t('assessmentYetToBegin2')}</Typography>
							<img width='470' alt={t('assessmentYetToBegin1')} src={assessmentYetToBegin} />
						</Box>
					</Box>
				</>
			)}
			{modalProps.open && (
				<AlertDialog message={t('unSavedItemAlert')} handleCloseModal={handleCloseModal} modalOpen={modalProps.open} />
			)}
		</>
	);
};
